import React from 'react'
import { FlexX } from '../FlexX'
import {
  AlignItemsEnum,
  JustifyContentEnum,
  OverflowEnum,
} from '../LayoutXenum'

type RowFlexProps = {
  children?: React.ReactNode
  className?: string
  crossAxisAlignment?: AlignItemsEnum
  fullWidth?: boolean
  gap?: string
  height?: string
  mainAxisAlignment?: JustifyContentEnum
  overflow?: OverflowEnum
}

export const RowFlex = ({
  children,
  className,
  crossAxisAlignment,
  fullWidth,
  gap,
  height,
  mainAxisAlignment,
  overflow,
}: RowFlexProps) => {
  return (
    <FlexX
      children={children}
      className={className}
      crossAxisAlignment={crossAxisAlignment}
      flexDirection="row"
      fullWidth={fullWidth}
      gap={gap}
      height={height}
      mainAxisAlignment={mainAxisAlignment}
      overflow={overflow}
    />
  )
}
